export default "__VITE_ASSET__DUl8x5Kt__"